import { useCallback } from "react";
import Link from "next/link";
import cls from "classnames";

export default function OnboardingNavBar({
  sticky = false,
  isLightMode = false,
  bodyBackgroundColor,
  showBorder = false,
}) {
  const current_screen = "nav";

  return (
    <>
      <header
        className={cls(
          "px-5 pt-[26px] pb-[18px] sm:px-8 md:px-16 lg:px-20 md:py-4 font-nunito z-10 w-full",
          sticky ? "sticky top-0 right-0" : "relative",
          isLightMode ? "text-[#16191B]" : "bg-[#16191B]",
          showBorder ? "border-b border-[#D5D8DC4D]" : null
        )}
        style={{ backgroundColor: isLightMode ? bodyBackgroundColor : null }}
      >
        <nav
          className={cls(
            "flex items-center justify-between w-full",
            isLightMode ? "text-[#16191B]" : "bg-[#16191B]"
          )}
          style={{ backgroundColor: isLightMode ? bodyBackgroundColor : null }}
        >
          <Link
            href={"https://qoohoo.in/"}
          >
            {isLightMode ? (
              <img
                src="/assets/images/qoohoo-logo-black.svg"
                alt="qoohoo Logo"
                className="w-[112px] h-9 min-w-[112px] min-h-[36px] lg:h-auto lg:w-auto select-none"
              />
            ) : (
              <img
                src="/assets/images/qoohoo-logo-white.svg"
                alt="qoohoo Logo"
                className="w-[112px] h-9 min-w-[112px] min-h-[36px] lg:h-auto lg:w-auto select-none"
              />
            )}
          </Link>
        </nav>
      </header>
    </>
  );
}
